import React, { useContext, useState } from "react";
import { observer } from "mobx-react";
import classNames from "classnames";

import { EventContext, LookupContext } from "@gp/components";
import { useIsAdditionalOfferVisible } from "@utils/offer";
import { useRootAppStore } from "@hooks";
import { useTranslation } from "react-i18next";
import { analyticsTracker } from "@utils/analytics";
import { Team } from "@gp/models";
import { THEME_SETTINGS } from "@theme-settings";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";

export const FavoritesButton = !THEME_SETTINGS.features.isFavoritesEnabled
	? () => null
	: observer(function FavoritesButton(props: {
			isOfferButton?: boolean;
			isOnHomepage?: boolean;
		}) {
			const { isOfferButton = false, isOnHomepage } = props;

			const event = useContext(EventContext);
			const isAdditionalOfferVisible = useIsAdditionalOfferVisible();
			const favoriteStore = useContext(FavoritesStoreContext);
			const lookupContext = useContext(LookupContext);
			const [isHover, setIsHover] = useState(false);
			const rootStore = useRootAppStore();
			const { t } = useTranslation();
			const isFavorite = favoriteStore.isUserFavoriteEvent(event.id);

			let t1: Team | undefined, t2: Team | undefined;

			t1 = lookupContext.teams.get(event.teamOneId || "");
			t2 = lookupContext.teams.get(event.teamTwoId || "");

			let tournament = lookupContext.tournaments.get(event.tournamentId);
			let sport = lookupContext.sports.get(event.sportId);

			const onButtonClick = () => {
				if (isFavorite) {
					favoriteStore.removeUserFavoriteEvent(event.id);
				} else {
					favoriteStore.addUserFavoriteEvent(event.id);

					analyticsTracker.trackEventFavorited(
						event.id,
						t1?.abrv || "",
						t2?.abrv || "",
						tournament?.abrv || "",
						sport?.abrv || ""
					);
				}
			};

			// class order matters here
			const buttonClasses = classNames(
				"at-addToFavsBtn",
				{
					offer__favorites__btn: isOfferButton && !isOnHomepage,
					event__actions__btn: !isOfferButton,
				},
				"btn",
				{
					"btn--square--reset btn--ghost": isOfferButton,
					"btn--square btn--square--sml btn--ghost": !isOfferButton,
				}
			);

			const iconClasses = classNames(
				{
					offer__favorites__icon: !isAdditionalOfferVisible,
					event__actions__icon: isAdditionalOfferVisible,
				},
				"u-icon u-icon--sml",
				{
					// "u-icon--sml": isOnHomepage,
					// "u-icon--sml": isOfferButton,
					// "u-icon--med": !isOfferButton,
					"u-icon--star--str u-color--sent--warning":
						isFavorite || (!isFavorite && isHover),
					"u-icon--star--alt u-color--sent--muted":
						!isFavorite && !isHover,
				}
			);

			const tooltipMessage = !rootStore.userAuthStore.isLoggedIn
				? t("FAVORITES.NONAUTH_TOOLTIP")
				: "";

			return (
				<button
					data-tooltip-id="tv-description"
					data-tooltip-content={tooltipMessage}
					data-tooltip-position-strategy="fixed"
					className={buttonClasses}
					type="button"
					onClick={onButtonClick}
					disabled={
						!rootStore.userAuthStore.isLoggedIn || event.isOutright
					}
					onMouseEnter={() => setIsHover(true)}
					onMouseLeave={() => setIsHover(false)}
				>
					<i className={iconClasses} />
				</button>
			);
		});
